import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'store'
import M_TableCell from 'components/1_Atoms/2_Molecules/M_TableCell'
import * as TableJuryoAction from 'slicers/TableSlicers/TableJuryoSlice'
import { getTimestampFromNumber } from 'utils/dateUtil'
import { organismLog } from 'utils/logUtil'
import { juryoTable } from 'assets/TableHeader'
import { responseJuryo } from 'utils/requestUtil'
import { getDenpyoKbnName } from 'utils/stringUtil'
import { FixPrice } from 'utils/numberUtil'

const width = juryoTable.width
const manualMode = process.env.REACT_APP_MANUAL_MODE === '1'

type Props = {
  isJapell: boolean
  joken: responseJuryo
  isChecked: boolean
  NAIYO: string
  selectListCount: number
  refs: React.MutableRefObject<React.RefObject<HTMLTableCellElement>[]>
  // no: number
}

const O_TableRowJoken = ({ isJapell, joken, isChecked, NAIYO, selectListCount, refs }: Props) => {
  useEffect(() => organismLog('O_TableRowJokenSummary'))
  const dispatch = useDispatch()
  const keyInfo = useSelector((state) => state.LoginReducer.keyInfo)
  // 固定する項目のleftを保持
  const [leftList, setLeftList] = useState<number[]>([])
  useEffect(() => {
    // 固定する項目のleftを算出
    const getLeft = (index: number) => {
      return refs.current?.reduce((prev, curr, i) => {
        if (i >= index) return prev
        if (curr.current?.getBoundingClientRect().width) prev = prev + Math.round(curr.current?.getBoundingClientRect().width * 100) / 100
        return prev
      }, 0)
    }
    const list = []
    for (let i = 0; i < refs.current.length; i++) list.push(getLeft(i))
    setLeftList(list)
  }, [...refs.current, selectListCount])

  // チェック処理 //================================//
  const handleRowClick = useCallback(() => {
    const data: responseJuryo = joken
    dispatch(TableJuryoAction.checkJoken({ isChecked: isChecked, checkData: data }))
  }, [])

  // 内容確認依頼フォーム処理 //================================//
  const onChangeNaiyo = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.preventDefault()
      dispatch(
        TableJuryoAction.changeNaiyo({
          ...joken,
          NAIYO: e.target.value,
        }),
      )
    },
    [NAIYO],
  )

  // 受領区分の表示名を取得 //================================//
  const getJuryoKbnName = (JURYO_KBN: 0 | 1 | 2) => {
    if (JURYO_KBN === 0) return '未受領'
    if (JURYO_KBN === 1) return '受領済'
    if (JURYO_KBN === 2) return '確認依頼'
    return ''
  }

  // 自分の店舗のデータかどうかを取得 //================================//
  const isTantoTenData = useMemo(() => {
    return keyInfo.some((r) => {
      return r.TOKUI_CD === joken.TOKUI_CD && r.TEN_CD === joken.TEN_CD && r.TEN_CD !== 0
    })
  }, [keyInfo, joken.TOKUI_CD, joken.TEN_CD])

  return (
    <>
      {/* No */}
      {/* <M_TableCell category="number" data={no} width={width.NO} click={handleRowClick} /> */}
      {/* チェックボックス */}
      <M_TableCell category="checkbox" isChecked={isChecked} width={width.CHECK} click={handleRowClick} left={leftList[0]} />
      {/* 受領区分 */}
      <M_TableCell
        category="data" //
        width={width.JURYO_KBN}
        align={'left'}
        title={joken.JURYO_KBN === 2 ? joken.NAIYO : getJuryoKbnName(joken.JURYO_KBN)}
        data={getJuryoKbnName(joken.JURYO_KBN)}
        click={handleRowClick}
        left={leftList[1]}
      />
      {/* 伝票日付 */}
      <M_TableCell
        category="data" //
        width={width.NOHIN_YMD}
        align={'left'}
        title={getTimestampFromNumber(joken.NOHIN_YMD, '/')}
        data={getTimestampFromNumber(joken.NOHIN_YMD, '/')}
        click={handleRowClick}
        left={leftList[2]}
      />
      {/* JANコード */}
      <M_TableCell
        category="data" //
        width={width.JAN_CD}
        align={'left'}
        title={joken.JAN_CD}
        data={joken.JAN_CD}
        click={handleRowClick}
        left={leftList[3]}
      />
      {/* 品名／規格 → 品名と規格を分離 JBCC塩川@20250521 */}
      {/* <M_TableCell
        category="data" //
        width={width.SHOHIN_KIKAKU}
        align={'left'}
        title={joken.SHOHIN_KIKAKU}
        data={joken.SHOHIN_KIKAKU}
        click={handleRowClick}
        left={leftList[4]}
      /> */}
      {/* 品名 */}
      <M_TableCell
        category="data" //
        width={width.SHOHIN}
        align={'left'}
        title={joken.SHOHIN}
        data={joken.SHOHIN}
        click={handleRowClick}
        left={leftList[4]}
      />
      {/* 規格 */}
      <M_TableCell
        category="data" //
        width={width.KIKAKU}
        align={'left'}
        title={joken.KIKAKU}
        data={joken.KIKAKU}
        click={handleRowClick}
        left={leftList[5]}
      />
      {/* 発注数 */}
      <M_TableCell
        category="data" //
        width={width.SURYO}
        align={'right'}
        title={FixPrice(joken.SURYO)}
        data={FixPrice(joken.SURYO)}
        click={handleRowClick}
        blackout={manualMode}
      />
      {/* 納品数 */}
      <M_TableCell
        category={joken.SURYO === joken.NOHIN_SURYO ? 'data' : 'errorData'} //
        width={width.NOHIN_SURYO}
        align={'right'}
        title={FixPrice(joken.NOHIN_SURYO)}
        data={FixPrice(joken.NOHIN_SURYO)}
        click={handleRowClick}
        blackout={manualMode}
      />
      {/* 内容確認依頼 */}
      <M_TableCell
        category={isJapell ? 'data' : 'form'} //
        width={!isJapell && selectListCount > 0 ? width.NAIYO_LONG : width.NAIYO}
        align={'left'}
        title={NAIYO}
        data={NAIYO}
        change={onChangeNaiyo}
        disabled={isJapell ? true : !(isChecked && isTantoTenData)}
        click={handleRowClick}
      />
      {/* 伝票区分 */}
      <M_TableCell
        category="data" //
        width={width.DENPYO_KBN}
        align={'left'}
        title={getDenpyoKbnName(joken.DENPYO_KBN)}
        data={getDenpyoKbnName(joken.DENPYO_KBN)}
        click={handleRowClick}
      />
      {/* 伝票番号 */}
      <M_TableCell
        category="data" //
        width={width.DENPYO_NO}
        align={'left'}
        title={joken.DENPYO_NO}
        data={joken.DENPYO_NO}
        click={handleRowClick}
        blackout={manualMode}
      />
      {/*行 */}
      <M_TableCell
        category="data" //
        width={width.GYO_NO}
        align={'right'}
        title={FixPrice(joken.GYO_NO)}
        // data={joken.GYO}
        data={FixPrice(joken.GYO_NO)}
        click={handleRowClick}
      />
      {/* 原単価 */}
      <M_TableCell
        category="data" //
        width={width.GEN_TANKA}
        align={'right'}
        title={FixPrice(joken.GEN_TANKA)}
        data={FixPrice(joken.GEN_TANKA)}
        click={handleRowClick}
        blackout={manualMode}
      />
      {/* 売単価 */}
      <M_TableCell
        category="data" //
        width={width.BAI_TANKA}
        align={'right'}
        title={FixPrice(joken.BAI_TANKA)}
        data={FixPrice(joken.BAI_TANKA)}
        click={handleRowClick}
        blackout={manualMode}
      />
      {/* 原価金額 */}
      <M_TableCell
        category="data" //
        width={width.GENKA}
        align={'right'}
        title={FixPrice(joken.GEN_TANKA * joken.NOHIN_SURYO)}
        data={FixPrice(joken.GEN_TANKA * joken.NOHIN_SURYO)}
        click={handleRowClick}
        blackout={manualMode}
      />
      {/* 売価金額 */}
      <M_TableCell
        category="data" //
        width={width.BAIKA}
        align={'right'}
        title={FixPrice(joken.BAI_TANKA * joken.NOHIN_SURYO)}
        data={FixPrice(joken.BAI_TANKA * joken.NOHIN_SURYO)}
        click={handleRowClick}
        blackout={manualMode}
      />
      {/* 得意先名 */}
      <M_TableCell
        category="data" //
        width={width.TOKUI_NM}
        align={'left'}
        title={joken.TOKUI_NM}
        data={joken.TOKUI_NM}
        click={handleRowClick}
      />
      {/* 店舗名 */}
      <M_TableCell
        category="data" //
        width={width.TEN_NM}
        align={'left'}
        title={joken.TEN_NM}
        data={joken.TEN_NM}
        click={handleRowClick}
      />
      {/* 事業所 */}
      {isJapell ? (
        <M_TableCell
          category="data" //
          width={width.JIGYO_NM}
          align={'left'}
          title={joken.JIGYO_NM}
          data={joken.JIGYO_NM}
          click={handleRowClick}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default React.memo(O_TableRowJoken)
